import { get } from '@alltrails/core/utils/get';
import Waypoint from '@alltrails/types/Waypoint';

export async function getMapWaypoints(mapId: number): Promise<Waypoint[]> {
  const response = await get<{ maps: (unknown & { waypoints: Waypoint[] })[] }>(`/api/alltrails/maps/${mapId}`, { params: { detail: 'deep' } });
  return response.maps[0].waypoints || [];
}

export async function getUserWaypoints({ globalOnly }: { globalOnly?: boolean } = {}): Promise<Waypoint[]> {
  const response = await get<{ waypoints: Waypoint[] }>(`/api/alltrails/my/waypoints`, {
    params: globalOnly ? { global_only: true } : undefined
  });
  return response.waypoints || [];
}
